/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

import { CustomAttributeData } from '../../../customAttributes/customAttributes';
import { ComponentDecimalInput } from '../../inputs/decimalInput/decimalInput';

interface ComponentCustomAttributeDecimalProps {
  attribute: CustomAttributeData,
  value: string,
  onValueChanged: (updatedValue: string) => void,
  editable: boolean,
  conditionalRangeMax : string | undefined,
  conditionalRangeMin: string | undefined,
}

export function ComponentCustomAttributeDecimal({
  attribute,
  value,
  onValueChanged,
  editable,
  conditionalRangeMax,
  conditionalRangeMin,
}: ComponentCustomAttributeDecimalProps): JSX.Element {

  // This will be called when the user leaves the input field
  const handleBlur = () => {

    if (attribute.propertiesDecimal === undefined) {
      return;
    }

    if (value === '') {
      return;
    }

    const valueAsNumber = Number(value);

    const { minValue, maxValue } = attribute.propertiesDecimal;

    let minValueAsNumber = minValue ? Number(minValue) : undefined;
    let maxValueAsNumber = maxValue ? Number(maxValue) : undefined;

    if (conditionalRangeMax && Number(conditionalRangeMax.replace(',', '.'))) {
      maxValueAsNumber = maxValueAsNumber ? Math.min(maxValueAsNumber, Number(conditionalRangeMax.replace(',', '.'))) : Number(conditionalRangeMax.replace(',', '.'));
    }

    if (conditionalRangeMin && Number(conditionalRangeMin.replace(',', '.'))) {
      minValueAsNumber = minValueAsNumber ? Math.max(minValueAsNumber, Number(conditionalRangeMin.replace(',', '.'))) : Number(conditionalRangeMin.replace(',', '.'));
    }

    if (minValueAsNumber && valueAsNumber < minValueAsNumber) {
      onValueChanged(`${minValueAsNumber}`);
      return;
    }

    if (maxValueAsNumber && valueAsNumber > maxValueAsNumber) {
      onValueChanged(`${maxValueAsNumber}`);
    }
  };

  if (attribute.propertiesDecimal === undefined) {
    return <div />;
  }

  return (
    <>
      <div className="col-3">
        <b style={{ color: attribute.color || '#000000' }}>{attribute.name}</b>
      </div>
      <div className="col-9">
        <ComponentDecimalInput
          id={attribute.key || ''}
          value={value}
          onChange={onValueChanged}
          onBlur={handleBlur}
          editable={editable}
        />
      </div>
    </>
  );
}
